export default {
    data() {
        return {
            isAuthenticated: false,
        };
    },
    methods: {
        checkAuthentication() {
            const token = localStorage.getItem("access_token");
            this.isAuthenticated = !!token;
            this.$root.$emit("authenticationChanged", this.isAuthenticated);
        },
    },
    mounted() {
        this.checkAuthentication();
    },
};